/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.CreateAccount";
        const PLACEHOLDER_TOP = "#createAccountPlaceholderTop";
        const PLACEHOLDER_BOTTOM = "#createAccountPlaceholderBottom";
        class CreateAccountWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("CreateAccountWidgetTypeClass.createInstance()");
                    return new CreateAccountWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("CreateAccountWidgetTypeClass._storeHtml()");
                    CreateAccountWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("CreateAccountWidgetTypeClass::constructor");
                this._allowedOnLogon = true;
                if (CreateAccountWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/CreateAccount/createAccount.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.CreateAccountWidgetTypeClass = CreateAccountWidgetTypeClass;
        class CreateAccountWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._formsConfig = null;
                this._reloadIcon = null;
                this._loader = null;
                this._formHolder = null;
                this._formHandler = null;
                this._currentFormName = null;
                this._currentFormData = null;
                this.presentInstance = () => {
                    this._log.info("CreateAccountWidgetInstanceClass.presentInstance()");
                    let presentInstance = false;
                    let config = this._config;
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('CreateAccount') && appConfig.CreateAccount.hasOwnProperty('Active') && appConfig.CreateAccount.Active) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("create account is activated");
                        }
                        if (config.hasOwnProperty('Forms') && config.Forms) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("forms section found in widget config");
                            }
                            presentInstance = true;
                            this._formsConfig = config.Forms;
                        }
                        else if (appConfig.CreateAccount.hasOwnProperty('Forms') && appConfig.CreateAccount.Forms) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("forms section found in application config");
                            }
                            let createAccConf = appConfig.CreateAccount;
                            if (createAccConf.hasOwnProperty('DisableModalForm') && createAccConf.DisableModalForm) {
                                switch (config.PlaceHolder) {
                                    case PLACEHOLDER_TOP:
                                        if (!createAccConf.hasOwnProperty('ShowFormAtBottom') || !createAccConf.ShowFormAtBottom) {
                                            presentInstance = true;
                                            this._formsConfig = appConfig.CreateAccount.Forms;
                                        }
                                        break;
                                    case PLACEHOLDER_BOTTOM:
                                        if (createAccConf.hasOwnProperty('ShowFormAtBottom') && createAccConf.ShowFormAtBottom) {
                                            presentInstance = true;
                                            this._formsConfig = appConfig.CreateAccount.Forms;
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                            else {
                                if (config.PlaceHolder != PLACEHOLDER_TOP && config.PlaceHolder != PLACEHOLDER_BOTTOM) {
                                    presentInstance = true;
                                    this._formsConfig = appConfig.CreateAccount.Forms;
                                }
                            }
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("create account is not activated");
                        }
                    }
                    if (!presentInstance) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("widget instance for '" + config.PlaceHolder + "' is not enabled");
                        }
                        return;
                    }
                    this._container.innerHTML = CreateAccountWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    // get elements to hold
                    this._reloadIcon = this._container.querySelector('#createAccountReload');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._formHolder = this._container.querySelector('#createAccountHolder');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#createAccountHeading'), 'STR_WPT_CREATEACCOUNT');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    // Translations
                    this._core.Helper.setElementTranslation(this._loader.querySelector('#createAccountLoading'), 'STR_WPT_LOADING');
                    // Event Listener
                    this._reloadIcon.addEventListener('click', this._reloadForm);
                    let eformConf = {};
                    if (config.hasOwnProperty('EFormConfig') && config.EFormConfig) {
                        eformConf = config.EFormConfig;
                    }
                    eformConf.SubmitFormCallback = this._submitCreateAccountForm;
                    this._formHandler = new Widgets.ComponentEFormHandler(this._core, this._formHolder, this, eformConf, null, this._hideLoader, this._showLoader);
                    this._formHandler.present();
                    this._loadForm();
                    this._type.instanceReady(this.getHandle());
                };
                this._loadForm = () => {
                    this._log.info("CreateAccountWidgetInstanceClass._loadForm()");
                    let formName = this._getFormFromConfig();
                    if (formName !== undefined) {
                        this._currentFormName = formName;
                        this._showLoader();
                        let url = '/GetEFormTemplate.ashx?name=' + formName;
                        this._core.Loader.genericServiceCallTextData(url, this._finishForm, this._formError, true);
                    }
                };
                this._getFormFromConfig = () => {
                    this._log.info("CreateAccountWidgetInstanceClass._getFormFromConfig()");
                    let localCode = this._core.Locale.getSelectedLocale().LocaleCode;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking for create account form for locale: " + localCode);
                    }
                    let formName = this._formsConfig[localCode];
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got create account form: " + formName);
                    }
                    if (formName === undefined) {
                        formName = this._formsConfig.Default;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using default create account form: " + formName);
                        }
                    }
                    return formName;
                };
                this._reloadForm = () => {
                    this._log.info("CreateAccountWidgetInstanceClass._reloadForm()");
                    this._clearErrors();
                    this._formHandler.checkChangesAndRun(this._formHandler.reloadForm);
                };
                this._hideLoader = () => {
                    this._log.info("CreateAccountWidgetInstanceClass._hideLoader()");
                    this._core.Functions.hideElement(this._loader);
                };
                this._showLoader = () => {
                    this._log.info("CreateAccountWidgetInstanceClass._showLoader()");
                    this._core.Functions.showElement(this._loader);
                };
                this._submitCreateAccountForm = (request) => {
                    this._log.info("CreateAccountWidgetInstanceClass._submitCreateAccountForm()");
                    this._core.Loader.genericServiceCallWithData('/User.svc/rest/CreateAccountStage1', JSON.stringify(request), this._submittedAccountForm, null, this._submitAccountError, this._submitAccountFailed, true);
                };
                this._submittedAccountForm = () => {
                    this._log.info("CreateAccountWidgetInstanceClass._submittedAccountForm()");
                    this._hideLoader();
                    this._formHandler.changesSaved();
                    this._core.Navigation.Logon.submittedCreateAccount();
                    this._reloadForm();
                };
                this._submitAccountError = (url, status, text) => {
                    this._log.info("CreateAccountWidgetInstanceClass._submitAccountError()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_CREATEACCOUNT_SUBMIT_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CREATEACCOUNT", "STR_WPT_ERROR", msgBody);
                };
                this._submitAccountFailed = (response) => {
                    this._log.info("CreateAccountWidgetInstanceClass._submitAccountFailed()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_CREATEACCOUNT_SUBMIT_ERROR_MSG');
                    let msgBody = msgPrefix;
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        msgBody += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                    }
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CREATEACCOUNT", "STR_WPT_ERROR", msgBody);
                };
                this._finishForm = (formData) => {
                    this._log.info("CreateAccountWidgetInstanceClass._finishForm()");
                    this._currentFormData = formData.ContentText;
                    this._formHandler.showFormTemplate(this._currentFormName, formData.ContentText);
                };
                this._formError = (url, status, text) => {
                    this._log.info("CreateAccountWidgetInstanceClass._formError()");
                    this._hideLoader();
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_CREATEACCOUNT_FORM_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CREATEACCOUNT", "STR_WPT_ERROR", msgBody);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("CreateAccountWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
        }
        CreateAccountWidgetInstanceClass.HtmlData = null;
        Widgets.CreateAccountWidgetInstanceClass = CreateAccountWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
